import { Component, OnInit } from '@angular/core';
import { FormBuilder, Validators, FormGroup } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { AccionesComponent } from 'src/app/acciones/acciones.component';
import { PerfilesComponent } from 'src/app/perfiles/perfiles.component';
import { AplicacionesService } from '../aplicaciones.service';
import { MensajeService } from '../../generico/servicio/mensaje.service';
import { Aplicacion } from 'src/app/_models/aplicacion';


@Component({
  selector: 'app-crear',
  templateUrl: './crear.component.html',
  styleUrls: ['./crear.component.scss']
})
export class CrearComponent implements OnInit{
  

  aplicacion : Aplicacion;
  crearAppForm : FormGroup;
  hide_password : boolean = true;
  readonly patron_contrasena : string = "^(?=.*\\d)(?=.*[\\.\\,\\_\\|\\(-\\)\\$-\\&])(?=.*[A-Z])(?=.*[a-z])\\S{8,16}$"

  constructor(private fb: FormBuilder,
              private dialog: MatDialog,
              public aplic: AplicacionesService, 
              private msg_serv : MensajeService) {}


  ngOnInit(): void {
    this.aplicacion = this.aplic.get_aplicacion();
    if (this.aplicacion){
      /**si es edicion la contraseña no es obligatoria. */
      this.crearAppForm = this.fb.group({
        txt_descripcion: [null, Validators.required],
        txt_clave: [null, [Validators.pattern(this.patron_contrasena)]],
        ind_estado: [this.aplicacion.ind_estado],
        num_sesiones: [null, [Validators.pattern('[0-9]+$')]],
      });

      this.llenar_forma();


    }else{
      this.crearAppForm = this.fb.group({
        txt_descripcion: [null, Validators.required],
        txt_clave: [null, [Validators.required,Validators.pattern(this.patron_contrasena)]],
        ind_estado: [1, []],
        num_sesiones: [null, [Validators.pattern('[0-9]+$')]],
      });
    }
  }

  onSubmit() {
    
    let value = this.crearAppForm.value;
    this.aplicacion = this.aplic.get_aplicacion();

    if (!this.aplicacion || !this.aplicacion.id_aplicacion){
      this.crear_app(value);
    }else{
      this.actualizar_app();
    }

  }

  abrirAcciones() {
    const dialogRef = this.dialog.open(AccionesComponent, {
      width: '800px',
    });

  }

  abrirPerfiles () {
    const dialogRef = this.dialog.open(PerfilesComponent, {
      width: '500px',
      height : '500px'
    });

  }

  /**
   * funcion que se ejecuta cuando se va ha crear una aplicacion 
   * @param value valor de la forma
   */
  public crear_app(value){

    if (!value.num_sesiones){
      let msg = 'No se ingresó la cantidad de sesiones por usuario, se creará una aplicación donde no se validara la cantidad de sesiones.\n ¿Desea continuar?';
      let target = document.querySelector('#btn_crear_app');

      target.addEventListener('crear_app_si', this.sesiones_indeterminadas);

      let json_botones = [
        {
          texto : 'Si', 
          evento : 'crear_app_si',
          parametros : {value, aplica_serv : this.aplic}
        },
        {
          texto : 'No', 
          evento : null,
          parametros : {}
        },
      ];
      this.msg_serv.ver_mensaje(msg, 
                                '',
                                this.msg_serv.TIPO_INFO,
                                target,
                                json_botones);
    }else{
      this.aplic.crearAplicacion(value);
    }

  }
  
  /**
   * funcion evento que crea la aplicacion con numero de sesiones indefenidas
   */
  public sesiones_indeterminadas(e){
    let value = e.detail.value;
    let aplic = e.detail.aplica_serv;
    value['num_sesiones'] = 0;
    aplic.crearAplicacion(value);
  }

  public actualizar_app(){
    
    let data = {}
    let value_form = this.crearAppForm.value

    if(this.aplicacion.txt_descripcion != value_form.txt_descripcion){
      data["txt_descripcion"] = value_form.txt_descripcion
    }

    if (this.aplicacion.num_sesiones != value_form.num_sesiones){
      data["num_sesiones"] = value_form.num_sesiones;
    }

    if (this.aplicacion.ind_estado != value_form.ind_estado){
      data["ind_estado"] = value_form.ind_estado ? 1 : 0;
    }

    if (value_form.txt_clave){
      data["txt_clave"] = value_form.txt_clave;
    }

    if (Object.keys(data).length){
      data["ind_update"] = 1
      data["id_aplicacion"] = this.aplicacion.id_aplicacion

      this.aplic.actualizar_aplicacion(data);
    }

  }

  /**
   * Funcion que se encarga de rellenar la forma con los datos de la aplicacion consultada.
   */
  public llenar_forma(){
    this.crearAppForm.get('txt_descripcion').setValue(this.aplicacion.txt_descripcion);
    this.crearAppForm.get('num_sesiones').setValue(this.aplicacion.num_sesiones);
  }

}
